export function gridModelToExcel(
  gridModel: any
): {
  keyMapJson: any;
  formatter: any;
} {
  let keyMapJson: any = {};
  let formatter: any = {};
  gridModel.forEach(function(value: any): void {
    let columnName = value['name'];
    keyMapJson[columnName] = value['header'];
    if (value['formatter']) {
      formatter[columnName] = value['formatter'];
    }
  });
  return {
    keyMapJson: keyMapJson,
    formatter: formatter
  };
}

export function ncpPopup(sURL: string, openTarget: any, w?: number, h?: number, scrollType: string = 'no', x = (screen.width - w) / 2, y = (screen.height - h) / 2): Window {
  if (screen.width == 800 && screen.height == 600) scrollType = 'yes';

  const options = `
    toolbar=no, 
    channelmode=no, 
    location=no, 
    directories=no, 
    menubar=no, 
    top=${y},
    left=${x}, 
    scrollbars=${scrollType}, 
    width=${w},
    height=${h}, 
    resizable=no
  `;

  const win = window.open(sURL, openTarget, options);
  win.moveTo(x, y);
  win.focus();

  return win;
}

export function popupResize(contentWidth?: number, contentHeight?: number, maxHeight?: number): void {
  let tempX = ($('#container') as any).width() + 30;
  let tempY = ($('.content') as any).height() + 110;
  if (contentWidth) {
    tempX = contentWidth;
  }

  if (contentHeight) {
    tempY = contentHeight;
  }
  if (maxHeight && tempY > maxHeight) {
    tempY = maxHeight;
  }
  window.resizeTo(tempX, tempY);
}
export function ncpJoin(array: any, separator: any): any {
  if (typeof array != 'object' || !array || array.length == 0) {
    return false;
  }

  let value: any[] = [];
  array.forEach((v: any): void => {
    if (v) {
      value.push(v);
    }
  });
  return value.join(separator);
}
